<template>
  <component :is="type" v-bind="linkProps(to)">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '../../../utils/validate';

export default {
  name: 'AppLink',
  props: {
    to: {
      type: String,
      required: true
    },
    // 是否以新窗口打开（数据大屏等独立展示页面）
    newWindow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isExternal() {
      return isExternal(this.to)
    },
    // 内部路由 + newWindow：同样以 a 标签在新窗口打开
    isNewWindow() {
      return this.newWindow && !isExternal(this.to)
    },
    type() {
      if (this.isExternal || this.isNewWindow) {
        return 'a'
      }
      return 'router-link'
    }
  },
  methods: {
    linkProps(to) {
      if (this.isExternal) {
        return {
          href: to,
          target: '_blank',
          rel: 'noopener'
        }
      }
      if (this.isNewWindow) {
        return {
          href: this.resolveHref(to),
          target: '_blank',
          rel: 'noopener'
        }
      }
      return {
        to: to
      }
    },
    // 把内部路由地址转换成可直接用于 href 的地址（hash 模式下形如 #/data-screen）
    resolveHref(to) {
      if (!this.$router) {
        return to
      }
      try {
        return this.$router.resolve(to).href
      } catch (e) {
        return to
      }
    }
  }
}
</script>